import { ref } from 'vue';
import { useCustomToast } from './useCustomToast';

export function useDateValidation() {
  const toast = useCustomToast();
  const selectedDate = ref<Date | null>(null);
  const isDatePickerOpen = ref(false);

  const validateDateNotPast = (date: Date): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    return checkDate >= today;
  };

  const validateDateNotFuture = (date: Date): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    return checkDate <= today;
  };

  const validateAndShowError = (date: Date | null): boolean => {
    if (!date) return false;

    if (!validateDateNotPast(date)) {
      toast.showErrorToast({
        title: 'Data inválida',
        message: 'A data preenchida não pode ser anterior ao dia de hoje.',
        type: 'error',
      });
      return false;
    }

    return true;
  };

  return {
    selectedDate,
    isDatePickerOpen,
    validateDateNotPast,
    validateDateNotFuture,
    validateAndShowError,
  };
}
